import { CancelDeleteDialog } from '@components/display/dialogs';
import { Button } from '@components/utility/buttons';
import { useComponentDetailContext } from '@contentManagement/contexts';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Stack, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useState } from 'react';

export const ComponentDetailEditBar = () => {
    const [_, setEditMode] = useComponentDetailContext().editModeState;
    const { dirty, resetForm, isSubmitting } = useFormikContext();
    const [isDiscardDialogOpen, setIsDiscardDialogOpen] = useState(false);

    const handleCancelClick = () => {
        if (dirty) {
            setIsDiscardDialogOpen(true);
            return;
        }

        setEditMode(false);
    };

    const handleConfirmDiscard = () => {
        resetForm();
        setEditMode(false);
        setIsDiscardDialogOpen(false);
    };

    return (
        <>
            <Stack direction="row" alignItems="center" gap="20px" flexShrink={1}>
                <Button.Neutral
                    variant="contained"
                    color="neutral-650"
                    className="black-border w-[174px] max-w-full min-w-0 shrink"
                    startIcon={<CloseIcon />}
                    onClick={handleCancelClick}
                    disabled={isSubmitting}
                >
                    <Typography fontSize="15px" fontWeight={500} letterSpacing="0.46px">
                        Cancel
                    </Typography>
                </Button.Neutral>
                <Button
                    variant="contained"
                    fullRounded
                    className="black-border w-[174px] max-w-full min-w-0 shrink"
                    startIcon={<CheckIcon />}
                    type="submit"
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    loadingPosition="start"
                >
                    <Typography fontSize="15px" fontWeight={500} letterSpacing="0.46px">
                        Save
                    </Typography>
                </Button>
            </Stack>
            <CancelDeleteDialog
                open={isDiscardDialogOpen}
                onClose={() => setIsDiscardDialogOpen(false)}
                title="Are you sure you want to discard your changes?"
                primary={{
                    label: 'Cancel editing',
                    onClick: handleConfirmDiscard,
                }}
                secondary={{
                    label: 'Go back',
                    onClick: () => setIsDiscardDialogOpen(false),
                }}
            />
        </>
    );
};
